import * as React from 'react';
export const IcHieferBreeding = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.29 15.29L16 17.59l-.29-.3a1.003 1.003 0 00-1.638.326 1.005 1.005 0 00.218 1.094l1 1a.999.999 0 001.42 0l3-3a1.004 1.004 0 10-1.42-1.42zM10 15a3 3 0 000 6h3a4.92 4.92 0 010-6h-3zm8.75-7h-.66c.552-1.264.86-2.621.91-4a1 1 0 00-1.89-.45 5.66 5.66 0 01-.77 1.14A6 6 0 0012 3a6 6 0 00-4.34 1.69 5.82 5.82 0 01-.77-1.14A1 1 0 005 4a11 11 0 00.91 4h-.66A2.25 2.25 0 003 10.25a.76.76 0 00.75.75h1.5c.307 0 .61-.065.89-.19.09.476.206.947.35 1.41.19.617.327 1.25.41 1.89A5 5 0 0110 13h4c.51.005 1.016.09 1.5.25.484-.16.99-.244 1.5-.25h.3c.06-.29.14-.56.21-.81.144-.463.26-.934.35-1.41.28.125.583.19.89.19h1.5a.76.76 0 00.75-.75A2.25 2.25 0 0018.75 8zM9 11a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2z'
      fill='currentColor'
    />
  </svg>
);
